// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        main: "#0D2C6B",
        contrast: "#ffffff",
    },
    secondary: {
        main: "#2F6E1C",
        contrast: "#ffffff",
    },
    tertiary: {
        main: "#505D67",
        contrast: "#ffffff",
    },
    common: {
        border: "#DBE0E6",
        borderLight: "#F3F5F7",
        borderDark: "#9CA5B2",
        accent: "#F3F5F7",
        accentContrast: "#505D67",
        background: "#ffffff",
        backgroundContrast: "#505D67",
        disabled: "#DBE0E6",
        // Custom
        accentLighter: "#F8F8F8",
        backgroundRgba: "rgba(255, 255, 255, 0.9)",
        borderColored: "#61BC46",
        disabledLighter: "#F8F8F8",
        disabledLight: "#F3F5F7",
    },
    text: {
        main: "#505D67",
        accent: "#9CA5B2",
        disabled: "#DBE0E6",
        link: "#2F6E1C",
        // Custom
        dark: "#36404C",
        darkest: "#333333",
        linkHover: "#2F6E1C",
        input: "#666666",
    },
    success: {
        main: "#36A053",
        contrast: "#ffffff",
        light: "#E8FDEE",
    },
    danger: {
        main: "#DF1642",
        contrast: "#ffffff",
        light: "#FFE9EF",
    },
    warning: {
        main: "#DA6F14",
        contrast: "#ffffff",
        light: "#FEF7EA",
    },
    info: {
        main: "#518CE3",
        contrast: "#EEF9FF",
        // Custom
        alt: "#DCE2F1",
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#9CA5B2", // Text Color -> Accent
        disabled: "#d6d7dc", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#d6d7dc", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#0D2C6B", // Text Color -> Main
        hover: "#505D67", // Primary -> Dark
        accent: "#2F6E1C", // Primary -> Main
        accentHover: "#505D67", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#0D2C6B",
            hover: "#2F6E1C",
            accent: "#0D2C6B",
            accentContrast: "#ffffff",
            accentHover: "#0D2C6B",
            border: "#DBE0E6",
        },
        secondaryNavigation: {
            main: "#505D67",
            contrast: "#505D67",
            hover: "#505D67",
        },
    },
    footer: {
        main: "#ffffff", // Gray Shades -> Light
        contrast: "#505D67", // Text Color -> Main
        alt: "#F8F8F8", // Primary -> Main
        altContrast: "#505D67", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#DBE0E6", // Border -> Border
        contrast: "#505D67", // Text Color -> Main
        hover: "#2F6E1C", // Primary -> Main
        selected: "#2F6E1C", // Primary -> Main
        selectedHover: "#505D67", // Primary -> Dark
    },
};

export default colors;
